<template>
  <div id="midialog">
    <v-toolbar flat color="white">
      <v-toolbar-title>Municipios</v-toolbar-title>
      <v-divider
        class="mx-4"
        inset
        vertical
      ></v-divider>
      <div class="flex-grow-1"></div>
      <v-dialog v-model="dialog" persistent>
        <v-form ref="form" v-model="valid">
          <template v-slot:activator="{ on }">
            <!-- se puso transaparent y text para np mostrarlo al hacer render la vista-->
            <v-btn color="transparent" text class="mb-2" v-on="on">Nuevo</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline"> Nuevo Municipio</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      v-model="municipio.nombre"
                      label="Nombre"
                      required
                      :rules="[v => !!v || 'Campo requerido']"
                      @input="v => { municipio.nombre = v.toUpperCase() }"
                      ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-toolbar>

  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      valid: true,
      municipio: {
        nombre: "",
        activo: 1
      }
    };
  },
  mounted() {
    this.dialog = true;
  },
  computed: {
    ...mapGetters(["getAllMunicipios"])
  },
  created() {
    this.$store.dispatch("GET_ALL_MUNICIPIOS", { url: "municipios" });
  },
  methods: {
    close() {
      this.dialog = false;
      return this.$router.push({ name: "Municipios" });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("SAVE_MUNICIPIO",  { url: "/municipio", data: this.municipio } ).then(res => {
          this.$swal({
            title: "Exito!!!",
            text: res.data.message,
            icon: 'success',
            confirmButtonText: "Aceptar"
          });
          this.$router.push({ name: "Municipios" });
        })
        .catch(error => {
          this.$swal({
            title: "Error!!!",
            text: error.response.data.message,
            icon: 'warning',
            confirmButtonText: "Aceptar"
          })
        });
      }
    }
  }
};
</script>
